module.exports = __webpack_public_path__ + "img/memry_tags.a47cc93f.png";